import Hero from '../components/home/Hero';
import Marquee from '../components/Marquee';
import ServicesShowcase from '../components/home/ServicesShowcase';
import ProjectShowcase from '../components/home/ProjectShowcase';
import ProcessSteps from '../components/home/ProcessSteps';
import Faq from '../components/home/Faq';
import CtaBand from '../components/CtaBand';

function HomePage() {
  return (
    <>
      <Hero />
      <Marquee />
      <ServicesShowcase />
      <ProjectShowcase />
      <ProcessSteps />
      <Faq />
      <CtaBand />
    </>
  );
}

export default HomePage;
